import { Component, OnInit, Input } from '@angular/core';
import { FormGroupFilters } from '../../table-filters/model/table-filter.model';
import { UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-input',
    templateUrl: './input.component.html',
    styleUrls: ['./input.component.scss'],
    imports: [ReactiveFormsModule]
})
export class InputComponent implements OnInit {
  @Input() filter: FormGroupFilters;
  @Input() form: UntypedFormGroup;

  constructor() { }

  ngOnInit() {
  }

}
